
export class DateHelper {
	static isDate(date: string){
		const parsed = Date.parse(date);

		return !isNaN(parsed);
	}

}
